import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { TabStyles } from '../../styles/TabStyles';
import { makeTestId } from '../../utils/Declarative';
import { ButtonWidget } from '../Button/ButtonWidgetShim';

const StyleName: string = TypeStyle.style({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'flex-end',
  $nest: {
    '& > button ~ button': { marginLeft: TabStyles.Spacing.MediumSpace }
  }
});

export interface DialogFooterButtonsProps {
  buttons: Array<ButtonWidget['props']>;
  testId?: string;
}

/** A convenience widget for use in the `footerContent` prop of `DialogWidget`, which aligns and spaces buttons in a standardized way. */
export const DialogFooterButtonsWidget: React.FunctionComponent<DialogFooterButtonsProps> = props =>
  <div className={StyleName} data-tb-test-id={makeTestId(props.testId!, 'Confirm-Cancel-Footer')}>
    {props.buttons.map((buttonProps, idx) => <ButtonWidget key={idx} {...buttonProps} />)}
  </div>;
DialogFooterButtonsWidget.displayName = 'DialogFooterButtonsWidget';
